import { Reducer } from "redux";
import { IDialogsState, DialogsActions, DialogsActionTypes } from "./types";

const dialogsInitialState: IDialogsState = {
  confirmDialog: {
    show: false,
    messageId: "dummyId",
    values: {},
    confirmCallback: () => null,
    cancelCallback: () => null
  },
  errorDialog: {
    show: false,
    messageId: "dummyId",
    values: {}
  },
  successDialog: {
    show: false,
    messageId: "dummyId",
    values: {}
  }
};

const showDialog = (state: IDialogsState, action: DialogsActions) => {
  const { message, values, dialogName, confirmCallback, cancelCallback } = action.payload;
  const newState = { ...state };
  const newDialog = {
    show: true,
    messageId: message,
    values: { ...values },
    confirmCallback,
    cancelCallback
  };
  newState[dialogName] = newDialog;
  return newState;
};

const closeDialog = (state: IDialogsState, action: DialogsActions) => {
  const { dialogName } = action.payload;
  const newState = { ...state };
  const newDialog = dialogsInitialState[dialogName];
  newState[dialogName] = { ...newDialog };
  return newState;
};

export const dialogsReducer: Reducer<IDialogsState, DialogsActions> = (state = dialogsInitialState, action) => {
  switch (action.type) {
    case DialogsActionTypes.CLOSE_DIALOG: {
      return closeDialog(state, action);
    }
    case DialogsActionTypes.SHOW_DIALOG: {
      return showDialog(state, action);
    }
    default:
      return state;
  }
};
